import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { Box } from "@mui/system";
import CommonProgress from "../../../components/loader/commonProgress";
import TemplateCard from "../../templates/components/TemplateCard";
import TemplateHeader from "../../templates/components/TemplateHeader";
import { useNavigate } from "react-router-dom";
import { DELETE_TEMPLATE, GET_TEMPLATE, GET_TEMPLATES } from "../../templates/services/templateService";
import { toast } from "react-toastify";

import { useDispatch } from "react-redux";
import { getAvailableTemplates } from "components/SpeechToText_v2/helpers/getAvailbleTemplates";
import { set_user_template_preferences } from "redux/actions/AuthActions";
import TemplateConfirmationDialog from "screens/templates/components/TemplateConfirmationDialog";

const ScalesPage = () => {
    const { i18n } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [templateList, setTemplateList] = useState([]);
    const navigate = useNavigate();

    const reduxDispatch = useDispatch();
    const updateTemplates = async () => {
        const response = await GET_TEMPLATES();
        const userTemplates = Array.isArray(response?.data)
            ? response.data.filter(
                template => template.templateType === "dynamic-questionnaire-template"
            )
            : [];
        setTemplateList(userTemplates);
        const availablePrompts = await getAvailableTemplates();
        reduxDispatch(set_user_template_preferences({ display: availablePrompts }));
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                await updateTemplates();
            } catch (e) {
                console.error(e);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, []);


    const handleEditClick = async (template) => {
        try {
            setIsLoading(true);
            const response = await GET_TEMPLATE(template.templateCode);
            navigate(`/customForms/templates/${template.templateCode}`, {
                state: {
                    data: response.data
                }
            }
            )
        } catch (e) {
            console.error("error retrieving the template ", e);
        } finally {
            setIsLoading(false);
        }
    }

    const [showPopup, setShowPopup] = useState(false);
    const [templateToDelete, setTemplateToDelete] = useState(null);
    const handleDeleteClick = (template) => {
        setTemplateToDelete(template);
        setShowPopup(true);
    };
    const confirmDelete = async () => {
        try {
            setIsLoading(true);
            closeConfirmationModal();
            await DELETE_TEMPLATE(templateToDelete.templateCode);
            await updateTemplates();
            toast.success(templateToDelete.templateName + i18n.t("templates.DELETE_SUCCESS"));
        } catch (e) {
            console.error("error deleting the template ", e);
            if (e?.status > 499) {
                toast.error(i18n.t("templates.SERVER_ERROR"));
            } else if (e?.code === "template-does-not-exits") {
                toast.error(i18n.t("templates.CODE_404"));
            }
        } finally {
            setIsLoading(false);
        }
    };
    const openConfirmationModal = () => {
        setShowPopup(true);
    }

    const closeConfirmationModal = () => {
        setShowPopup(false);
        setTemplateToDelete(null);
    }

    return (
        <>
            <TemplateConfirmationDialog
                open={showPopup}
                title={''}
                message={i18n.t("templates.DELETE_CONFIRMATION")}
                onConfirm={confirmDelete}
                onCancel={closeConfirmationModal}
            />
            <Box
                className='h-100'
                sx={{
                    padding: '1.5rem'
                }}
            >
                {/* <TemplateHeader onCreate={handleCreateTemplate} /> */}
                {isLoading ?
                    <div className="d-flex h-100 justify-content-center align-items-center">
                        <CommonProgress />
                    </div> :
                    (
                        templateList?.length < 1 ?
                            <div className="d-flex h-100 justify-content-center align-items-center">
                                <Typography variant="h4" component="h3">
                                    {i18n.t("templates.NO_SCALES")}
                                </Typography>
                            </div>
                            :
                            templateList.map((template, i) => {
                                return (
                                    <TemplateCard
                                        template={template}
                                        onEditClick={() => { handleEditClick(template) }}
                                        onDeleteClick={() => handleDeleteClick(template)}
                                    />
                                )
                            })
                    )
                }
            </Box>
        </>
    );
}

export default ScalesPage;